import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './../material';
import { ColorPickerModule } from 'ngx-color-picker';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { NgxPaginationModule } from 'ngx-pagination';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { WidgetCompanyComponent } from './../widget-company/widget-company.component';
import { WidgetAdminComponent } from './../widget-admin/widget-admin.component';

import { AdministratorComponent } from './../administrator/administrator.component';
import { LeaderComponent } from '@leader/leader.component';
import { AnalystComponent } from './../analyst/analyst.component';
import { CustomerComponent } from './../customer/customer.component';
import { UserComponent } from '@user/user.component';
import { AdminListComponent } from './../administrator/admin-list/admin-list.component';
import { LeaderListComponent } from './../leader/leader-list/leader-list.component';
import { AnalystListComponent } from './../analyst/analyst-list/analyst-list.component';
import { CustomerListComponent } from './../customer/customer-list/customer-list.component';
import { UserFormComponent } from '@user/user-form/user-form.component';
import { CompanyFormComponent } from '@company/company-form/company-form.component';
import { CompanyListComponent } from '@company/company-list/company-list.component';
import { CompanyDetailComponent } from '@company/company-detail/company-detail.component';
import { CheckListBoardComponent } from './../checklist-board/checklist-board.component';
import { ModuleComponent } from './../module/module.component';
import { GroupComponent } from './../group/group.component';
import { CompanyModuleComponent } from '@module/company-module/company-module.component';
import { CompanyCardComponent } from '@module/company-module/company-card/company-card.component';
import { LinkGroupsComponent } from '@module/company-module/link-groups/link-groups.component';
import { TableauDashboardComponent } from '@base/tableau-dashboard/tableau-dashboard.component';
import { TableauWorkbookComponent } from '@base/tableau-dashboard/tableau-workbooks/tableau-workbooks.component';
import { TableauWorkbookViewComponent } from '@base/tableau-dashboard/tableau-workbook-view/tableau-workbook-view.component';
import { TableauViewsComponent } from '@base/tableau-dashboard/tableau-views/tableau-views.component';
import { WorkbookOptionComponent } from '@module/company-module/workbook-option/workbook-option.component';
import { TagComponent } from '@tag/tag.component';
import { EtlComponent } from '@etl/etl.component';
import { EtlListComponent } from '@etl/list/list.component';
import { RoleComponent } from '@role/role.component';
import { RoleListComponent } from '@role/list/list.component';
import { RoleFormComponent } from '@role/form/form.component';

import { AppService } from './../app.service';
import { UserService } from '@user/user.service';
import { AdministratorService } from './../administrator/administrator.service';
import { CompanyService } from '@company/company.service';
import { ModuleService } from './../module/module.service';
import { GroupService } from './../group/group.service';
import { MemberService } from './../member/member.service';
import { CompanyUserService } from '@base/company-user/company-user.service';
import { LoggerService } from '@logger/logger.service';
import { TableauService } from '@tableau/tableau.service';
import { TableauLinkService } from '@tableau/tableau-link.service';
import { WorkbookService } from '@workbook/workbook.service';
import { TagService } from '@tag/tag.service';

import { ApplicationHttpClient, applicationHttpClientCreator } from './../http-client';
import { DialogComponent } from '@dialog/dialog.component';
import { LeaderDashboardComponent } from '@leader/leader-dashboard/leader-dashboard.component';
import { ChartComponent } from '@charts/chart.component';

import { DirectivesModule } from '@directives/directives.module';

import { ChartsModule } from 'ng2-charts';

// resolvers
import { HomeResolver } from './home.resolver';
import { UserResolver } from '@user/user.resolver';
import { CompanyResolver } from '@company/company.resolver';
import { AuthResolver } from '@auth/auth.resolver';

import { StringFilterPipe } from '@pipes/string-filter.pipe';
import { StatusFieldPipe } from '@pipes/status.pipe';
import { SafePipe } from '@pipes/safe.pipe';
import { CustomDatePipe } from '@pipes/custom-date.pipe';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare, faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faSquare as farSquare, faCheckSquare as farCheckSquare } from '@fortawesome/free-regular-svg-icons';
// import { faStackOverflow, faGithub, faMedium } from '@fortawesome/free-brands-svg-icons';

import { EtlModule } from '@etl/etl.module';
import { WorkbookModule } from '@workbook/workbook.module';
import { ViewModule } from '@view/view.module';
import { RoleModule } from '@role/role.module';
import { TableauDashboardModule } from '@base/tableau-dashboard/tableau-dashboard.module';

@NgModule({
  declarations: [
    HomeComponent,
    WidgetCompanyComponent,
    WidgetAdminComponent,
    AdministratorComponent,
    LeaderComponent,
    AnalystComponent,
    CustomerComponent,
    UserComponent,
    UserFormComponent,
    AdminListComponent,
    LeaderListComponent,
    AnalystListComponent,
    CustomerListComponent,
    CompanyFormComponent,
    CompanyListComponent,
    CompanyDetailComponent,
    CheckListBoardComponent,
    ModuleComponent,
    GroupComponent,
    LeaderDashboardComponent,
    ChartComponent,
    CompanyModuleComponent,
    CompanyCardComponent,
    LinkGroupsComponent,
    WorkbookOptionComponent,
    TagComponent,
    EtlComponent,
    EtlListComponent,
    RoleComponent,
    RoleListComponent,
    RoleFormComponent,

    StringFilterPipe,
    StatusFieldPipe,
    SafePipe,
    CustomDatePipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    MaterialFileInputModule,
    DirectivesModule,
    ChartsModule,
    NgxPaginationModule,
    FontAwesomeModule,

    EtlModule,
    WorkbookModule,
    ViewModule,
    RoleModule,
    TableauDashboardModule,

    HomeRoutingModule,
  ],
  exports: [
    WidgetCompanyComponent,
    WidgetAdminComponent,
    AdministratorComponent,
    LeaderComponent,
    AnalystComponent,
    CustomerComponent,
    UserComponent,
    UserFormComponent,
    AdminListComponent,
    LeaderListComponent,
    AnalystListComponent,
    CustomerListComponent,
    CompanyFormComponent,
    CompanyListComponent,
    CompanyDetailComponent,
    CheckListBoardComponent,
    ModuleComponent,
    GroupComponent,
    StringFilterPipe,
    StatusFieldPipe,
    SafePipe,
    CustomDatePipe,
    LeaderDashboardComponent,
    ChartComponent,
    NgxPaginationModule,
    FontAwesomeModule,
    CompanyModuleComponent,
    CompanyCardComponent,
    LinkGroupsComponent,
    WorkbookOptionComponent,
    EtlComponent,
    EtlListComponent,
    RoleComponent,
    RoleListComponent,
    RoleFormComponent,
  ],
  providers: [
    AppService,
    {
      provide: ApplicationHttpClient,
      useFactory: applicationHttpClientCreator,
      deps: [HttpClient]
    },
    UserService,
    AdministratorService,
    CompanyService,
    ModuleService,
    GroupService,
    MemberService,
    CompanyUserService,
    LoggerService,
    TableauService,
    TableauLinkService,
    WorkbookService,
    TagService,

    // resolvers
    HomeResolver,
    UserResolver,
    CompanyResolver,
    AuthResolver,
  ],
  entryComponents: [
    DialogComponent,
  ]
})
export class HomeModule {
  constructor() {
    // Add an icon to the library for convenient access in other components
    // library.add(farSquare);
  }
}
